module.exports = __webpack_public_path__ + "c_static/img/pop_img_Red-envelope_default@2x.503fec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/pop_img_Red-envelope_default@2x.png
// module id = 7BiR
// module chunks = 33